<div *ngIf="progress" class="progress-flow-container" [ngStyle]="{'border-radius': borderRadius}">
  <div class="banner" *ngIf="progress.Background == 'VerticalProgress'"></div>
  <div *ngIf="nodeList">
    <div class="wrap">
      <div class="transaction-progress">
        <div *ngFor="let node of nodeList;let i=index;let last=last" class="progress-item" [ngStyle]="{'flex': '0 0 ' + 100 / nodeList.length + '%'}" [class.active]="node.IsSelected" 
        [class.full-active]="node.IsFullSelected">
            <div class="stepper-image" >
              <div class="">
                <div class="item-container" [ngStyle]="{'transition-delay': !node.IsSelected ? '0s' : node.DelayAmount ? (node.DelayAmount + 0.5) + 's' : '0.5s' }">
                  <div 
                  [ngClass]="{'stepper-icon': true, 'selected': node.IsSelected}"
                  [ngStyle]="{'transition-delay': !node.IsSelected ? '0s' : node.DelayAmount ? (node.DelayAmount + 0.5) + 's' : '0.5s',
                'background-image': node.IsSelected ? 'url(../../assets/images/progress-icon/' + node.Icon.toLowerCase() + '-selected.png)' : 
                'url(../../assets/images/progress-icon/' + node.Icon.toLowerCase() + '.png)'}" [title]="node.Label"></div>
                </div>
              </div>
              <!-- <div class="md-step-bar-title" *ngIf="node.Label" (click)="node.IsSelected = !node.IsSelected">{{node.Label}}</div> -->
            </div>
            <div class="md-step-bar-top line-background"></div>
            <div class="md-step-bar-top progress" [ngStyle]="{'transition-delay': node.DelayAmount ? node.DelayAmount + 's' : '0s' }"></div>
            <div *ngIf="last" class="md-step-bar-bottom line-background"></div>
            <div *ngIf="last" class="md-step-bar-bottom progress"></div>
          </div>
      </div>
    </div>
  </div>
</div>